(() => {
  const SESSION_KEY = "khs-storefront-intro-seen";
  const MOBILE_QUERY = "(max-width: 749px)";
  const IDLE_TIMEOUT = 1500;

  const rememberIntro = () => {
    try {
      sessionStorage.setItem(SESSION_KEY, "true");
    } catch (_) {
      // Storage can be unavailable in privacy modes; the hero still fails safe.
    }
  };

  const hasSeenIntro = () => {
    try {
      return sessionStorage.getItem(SESSION_KEY) === "true";
    } catch (_) {
      return false;
    }
  };

  document.querySelectorAll("[data-cinematic-hero]").forEach((hero) => {
    if (hero.dataset.cinematicReady === "true") return;
    hero.dataset.cinematicReady = "true";

    const video = hero.querySelector("[data-cinematic-video]");
    const skip = hero.querySelector("[data-cinematic-skip]");
    const reducedMotion = matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    const mobileQuery = matchMedia(MOBILE_QUERY);
    const saveData = navigator.connection?.saveData === true;
    let completed = false;
    let idleHandle;
    let timeoutHandle;

    const cancelDeferredLoad = () => {
      if (idleHandle !== undefined && "cancelIdleCallback" in window) {
        window.cancelIdleCallback(idleHandle);
      }
      if (timeoutHandle !== undefined) window.clearTimeout(timeoutHandle);
    };

    const showCompletedHero = (keepFinalFrame = false) => {
      if (completed) return;
      completed = true;
      cancelDeferredLoad();
      rememberIntro();
      video?.pause();
      if (keepFinalFrame) hero.classList.add("is-cinematic-complete");
      else if (video) {
        video.removeAttribute("src");
        video.load();
      }
      hero.classList.remove("is-cinematic-pending");
      hero.classList.remove("is-cinematic-playing");
      hero.classList.add("is-cinematic-revealing");
      setTimeout(() => {
        hero.classList.remove("is-cinematic-revealing");
        if (!keepFinalFrame) video?.remove();
      }, 900);
    };

    if (!video || reducedMotion || saveData || hasSeenIntro()) {
      video?.remove();
      return;
    }

    rememberIntro();
    hero.classList.add("is-cinematic-pending");
    video.addEventListener("ended", () => showCompletedHero(true), {
      once: true,
    });
    video.addEventListener("error", () => showCompletedHero(), { once: true });
    skip?.addEventListener("click", () => showCompletedHero(), { once: true });
    mobileQuery.addEventListener?.("change", () => showCompletedHero(), {
      once: true,
    });

    const beginPlayback = () => {
      if (completed) return;

      video.src = mobileQuery.matches
        ? video.dataset.mobileSrc
        : video.dataset.desktopSrc;
      video.load();

      video.addEventListener(
        "canplay",
        () => {
          if (completed) return;
          const playback = video.play();
          if (!playback) {
            hero.classList.remove("is-cinematic-pending");
            hero.classList.add("is-cinematic-playing");
            return;
          }
          playback
            .then(() => {
              if (completed) return;
              hero.classList.remove("is-cinematic-pending");
              hero.classList.add("is-cinematic-playing");
            })
            .catch(showCompletedHero);
        },
        { once: true },
      );
    };

    const deferPlayback = () => {
      if ("requestIdleCallback" in window) {
        idleHandle = window.requestIdleCallback(beginPlayback, {
          timeout: IDLE_TIMEOUT,
        });
      } else {
        timeoutHandle = window.setTimeout(beginPlayback, 200);
      }
    };

    if (document.readyState === "complete") deferPlayback();
    else window.addEventListener("load", deferPlayback, { once: true });
  });
})();
